import { useIntl } from 'react-intl';
import { StyledApproveRegistrationPageWrapper } from './style';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Icon, Spinner } from 'ui';
import useQueryApiClient from 'utils/useQueryApiClient';
import { fetchCsrfCookie } from 'utils/csrfCookie';
import { useEffect, useState } from 'react';
import { AuthProps, useAuth } from 'hooks/useAuth';
import PublicRoute from 'enums/publicRoutes';
import { adminPath } from 'enums/adminRoutes';

export const ApproveRegistrationPage = () => {
  const { authenticate } = useAuth();
  const [isApproved, setIsApproved] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const intl = useIntl();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();

  const token = searchParams.get('token');

  const { appendData } = useQueryApiClient({
    request: {
      url: '/api/v2/confirm-email',
      method: 'POST',
    },
    onSuccess: (response) => {
      authenticate({ authenticated: response.authenticated } as AuthProps);

      if (response?.farmId) {
        setTimeout(() => {
          navigate(adminPath.roles());
        }, 1000);

        return;
      }

      setIsApproved(true);
      setIsLoading(false);
    },
    onError: () => {
      setIsApproved(false);
      setIsLoading(false);
    },
  });

  useEffect(() => {
    if (!token) {
      setIsLoading(false);
      return;
    }

    const confirm = async () => {
      await fetchCsrfCookie();
      appendData({ token });
    };

    confirm();
  }, []);

  return (
    <StyledApproveRegistrationPageWrapper>
      <div className={'content'}>
        <div className={'content_inner'}>
          <div className={'close-button-wrapper'}>
            <Icon name={'global-close-icon'} onClick={() => navigate(PublicRoute.HOME)} />
          </div>
          <Spinner spinning={isLoading} dontRender>
            {isApproved ? (
              <div className="box">
                <div>
                  <h2 className={'title'}>
                    {intl.formatMessage({
                      id: 'successful_registration.title',
                    })}
                  </h2>
                  <p className={'text'}>
                    {intl.formatMessage({ id: 'successful_registration.text' })}
                  </p>
                </div>
                <div className={'approve-registration-wrapper-btns'}>
                  <Button
                    type={'text'}
                    className={'approve-registration-wrapper-btn'}
                    label={intl.formatMessage({
                      id: 'successful_registration.shop',
                    })}
                    onClick={() => navigate(PublicRoute.HOME)}
                  />
                </div>
              </div>
            ) : (
              <div className={'box unsuccess'}>
                <h2 className={'title'}>
                  {intl.formatMessage({
                    id: 'successful_registration.unsuccess',
                  })}
                </h2>
                <div className={'approve-registration-wrapper-btns'}>
                  <Button
                    type={'text'}
                    className={'approve-registration-wrapper-btn'}
                    label={intl.formatMessage({
                      id: 'successful_registration.shop',
                    })}
                    onClick={() => navigate(PublicRoute.HOME)}
                  />
                </div>
              </div>
            )}
          </Spinner>
        </div>
      </div>
    </StyledApproveRegistrationPageWrapper>
  );
};
